import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import layout from '@/layout/index'
import home from '@/pages/home/index'
import people from '@/pages/people/index'
import publication from '@/pages/publication/index'
import research from '@/pages/research/index'
import joinus from '@/pages/joinus/index'
import news from '@/pages/news/index'
import xuxiaoliang from '@/pages/teacher/xuxiaoliang'
import wangyuxiang from '@/pages/teacher/wangyuxiang'
import xiayixing from '@/pages/teacher/xiayixing'
import fangqiming from '@/pages/teacher/fangqiming'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      redirect: "/home",
      component: layout,
      children: [
        {
          path: "home",
          name: "home",
          component: home
        },
        {
          path: "people",
          name: "people",
          component: people
        },
        {
          path: "publication",
          name: "publication",
          component: publication
        },
        {
          path: "research",
          name: "research",
          component: research
        },
        {
          path: "joinus",
          name: "joinus",
          component: joinus
        },
        {
          path: "news",
          name: "news",
          component: news
        },
        {
          path: "xuxiaoliang",
          name: "xuxiaoliang",
          component: xuxiaoliang
        },
        {
          path: "wangyuxiang",
          name: "wangyuxiang",
          component: wangyuxiang
        },
        {
          path: "xiayixing",
          name: "xiayixing",
          component: xiayixing
        },
        {
          path: "fangqiming",
          name: "fangqiming",
          component: fangqiming
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js